<div class="modal-header">
  <h6 class="modal-title d-flex align-items-center gap-2">
    <ng-container i18n>Guest Sentiments</ng-container>
  </h6>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <span><i class="far fa-times"></i></span>
  </button>
</div>
<div class="modal-body bg-none p-0 m-0">
  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 w-100" multiTemplateDataRows>
      <ng-container matColumnDef="guest">
        <th mat-header-cell *matHeaderCellDef i18n>Guest Name</th>
        <td mat-cell *matCellDef="let element">
          <app-avatar-name [name]="element.review?.reviewer.name" [size]="35"></app-avatar-name>
        </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef i18n>Date</th>
        <td mat-cell *matCellDef="let element">{{ element.review?.submittedAt | epoch }}</td>
      </ng-container>
      <ng-container matColumnDef="rental">
        <th mat-header-cell *matHeaderCellDef i18n>Rental</th>
        <td mat-cell *matCellDef="let element">
          <app-rental-name [rentalId]="element.review?.rentalId"></app-rental-name>
        </td>
      </ng-container>
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef i18n>Summary</th>
        <td mat-cell *matCellDef="let element">
          <div class="text-truncate" [matTooltip]="element.summary">
            {{ element.summary }}
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator2
      #paginator
      [length]="dataSource?.data?.length"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>
  </div>
</div>
